var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPuzzle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 21.25C31.25 21.25 31.25 25 27.5 22.5V15C27.5 13.625 26.375 12.5 25 12.5H17.5C15 8.75 18.75 8.75 18.75 5C18.75 2.23875 16.5112 0 13.75 0C10.9887 0 8.75 2.23875 8.75 5C8.75 8.75 12.5 8.75 10 12.5H2.5C1.125 12.5 0 13.625 0 15V37.5C0 38.875 1.125 40 2.5 40H10C12.5 36.25 8.75 36.25 8.75 32.5C8.75 29.7388 10.9887 27.5 13.75 27.5C16.5112 27.5 18.75 29.7388 18.75 32.5C18.75 36.25 15 36.25 17.5 40H25C26.375 40 27.5 38.875 27.5 37.5V30C31.25 27.5 31.25 31.25 35 31.25C37.7612 31.25 40 29.0112 40 26.25C40 23.4888 37.7612 21.25 35 21.25Z",
    fill: "url(#paint0_linear_1072_425)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1072_425",
    x1: 0.734375,
    y1: 39.2663,
    x2: 27.9106,
    y2: 12.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7055C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D055C2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzle);
export default __webpack_public_path__ + "static/media/puzzle.9c3f08f2b6c84283dab7f5dab5e0ae95.svg";
export { ForwardRef as ReactComponent };